module.exports = __webpack_public_path__ + "img/streak5.bddd3c95.png";